/*
 * Get Manual Disposition Reasons GraphQL specification
 * @module src/graphql/getManualDispositionReasons
 */
/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const GET_MANUAL_DISPOSITION_REASONS = gql`
  query getManualDispositionReasons {
    getManualDispositionReasons {
      id
      reasonName
      reasonDescription
      isActive
    }
  }
`;
